import { BeforePhaseRingIcon, CompletedPhaseTickIcon, DuringPhaseRingIcon, ErrorIcon } from "../../../../../../assets";
import { ColorConstants } from "../../../../../../constants";
import { ProjectPhaseStatus } from "../../../../../../models";
import { convertDateToStringDDMMYYYY } from "../../../../../../utils";

interface PhaseSectionProps {
  phase: string;
  start?: Date;
  end?: Date;
  status?: ProjectPhaseStatus;
}

export const PhaseSection = ({ phase, start, end, status }: PhaseSectionProps): JSX.Element | undefined => {
  const isMissingDates = !start || !end;

  const isIncorrectDates =
    end?.getTime() !== undefined && new Date().getTime() > end?.getTime() && status !== ProjectPhaseStatus.COMPLETED;

  if (isMissingDates || isIncorrectDates) {
    return (
      <div className="PhaseSection Invalid">
        <ErrorIcon fill={ColorConstants.GOLDENROD_500} />
        <p className="body2">{phase}</p>
        <p className="body5">
          {isMissingDates
            ? "Please add the start and end dates for this phase."
            : "Please configure the dates for this phase so they align with the project's current lifecycle."}
        </p>
      </div>
    );
  }

  return (
    <div className={`PhaseSection ${status?.replace(" ", "")}`}>
      {status === ProjectPhaseStatus.NOT_STARTED && <BeforePhaseRingIcon />}
      {status === ProjectPhaseStatus.IN_PROGRESS && <DuringPhaseRingIcon />}
      {status === ProjectPhaseStatus.COMPLETED && <CompletedPhaseTickIcon />}
      <p className="body2">{phase}</p>
      <p className="body5">{`${convertDateToStringDDMMYYYY(start)} - ${convertDateToStringDDMMYYYY(end)}`}</p>
    </div>
  );
};
